"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.portal = void 0;
const sp10_1 = require("../sp10/sp10");
const favicon_ico_1 = __importDefault(require("./logo/favicon.ico"));
const logo_png_1 = __importDefault(require("./logo/gray/logo.png"));
const service_pro_portal_logo_png_1 = __importDefault(require("./logo/gray/service-pro-portal-logo.png"));
const service_pro_portal_logo_png_2 = __importDefault(require("./logo/service-pro-portal-logo.png"));
const logo_png_2 = __importDefault(require("./logo/logo.png"));
exports.portal = {
    ...sp10_1.sp10,
    name: "Service Pro Portal",
    "loading-text-color": "#fff",
    "login-header-logo-url": service_pro_portal_logo_png_2.default,
    "login-logo-url": logo_png_1.default,
    "app-logo-url": logo_png_1.default,
    "app-logo-color-url": logo_png_2.default,
    "app-logo-tagline-url": service_pro_portal_logo_png_1.default,
    favicon: favicon_ico_1.default,
    "all-orders-color": "#800080",
    "in-progress-color": "#0078d7",
    "completed-color": "#0ac92b",
    "on-hold-color": "#ff6e6e",
    "scheduled-color": "#f89406"
};
//# sourceMappingURL=portal.js.map